import { useTranslation } from 'react-i18next'
import * as Styled from '../../../screens/KnowledgeBase/knowledgeBase.styles'

interface KnowledgeBaseDisplayContentFallbackParams {
  downloadFilePath: string
}

const KnowledgeBaseDisplayContentFallback = ({
  downloadFilePath,
}: KnowledgeBaseDisplayContentFallbackParams) => {
  const { t } = useTranslation()

  return (
    <div>
      <p>{t('common.errors.fileNoBrowserSupport')}</p>
      <Styled.DisplayButton>
        <Styled.DownloadLink href={downloadFilePath} target='_blank'>
          {t('knowledgeBase.downloadFile')}
        </Styled.DownloadLink>
      </Styled.DisplayButton>
    </div>
  )
}

export { KnowledgeBaseDisplayContentFallback }
